import { Theme } from "@mui/material";

/**
 * Standardized glass-card styling for consistent frosted glass effect
 * across modals, drawers, menus, and other overlay components
 * 
 * Usage:
 * ```tsx
 * <Dialog
 *   PaperProps={{
 *     sx: (theme) => ({
 *       ...getGlassCardStyles(theme),
 *       // Additional custom styles
 *     }),
 *   }}
 * />
 * ```
 */
export const getGlassCardStyles = (theme: Theme) => ({
  backgroundColor: theme.palette.mode === "dark"
    ? "rgba(18, 18, 18, 0.4)"
    : "rgba(255, 255, 255, 0.75)",
  backdropFilter: "blur(16px)",
  WebkitBackdropFilter: "blur(16px)",
  border: `1px solid ${
    theme.palette.mode === "dark"
      ? "rgba(255,255,255,0.1)"
      : "rgba(0,0,0,0.08)"
  }`,
  boxShadow: theme.palette.mode === "dark"
    ? "0 8px 32px rgba(0,0,0,0.3), 0 2px 8px rgba(0,0,0,0.15)"
    : "0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08)",
});

/**
 * Standardized glass-card background only (for custom components)
 */
export const getGlassCardBackground = (theme: Theme) => ({
  backgroundColor: theme.palette.mode === "dark"
    ? "rgba(18, 18, 18, 0.4)"
    : "rgba(255, 255, 255, 0.75)",
  backdropFilter: "blur(16px)",
  WebkitBackdropFilter: "blur(16px)",
});

/**
 * Standardized glass-card border
 */
export const getGlassCardBorder = (theme: Theme) => ({
  border: `1px solid ${
    theme.palette.mode === "dark"
      ? "rgba(255,255,255,0.1)"
      : "rgba(0,0,0,0.08)"
  }`,
});

/**
 * Standardized glass-card shadow
 */
export const getGlassCardShadow = (theme: Theme) => ({
  boxShadow: theme.palette.mode === "dark"
    ? "0 8px 32px rgba(0,0,0,0.3), 0 2px 8px rgba(0,0,0,0.15)"
    : "0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08)",
});

